module.exports = __webpack_public_path__ + "static/media/pause-circle.b6d6f62f.svg";